import About from '../components/About';
import Artists from '../components/Artists';
import Audio from '../components/Audio';
import EventList from '../components/EventsList';
import Hero from '../components/Hero';
import Locations from '../components/Locations';
import PartnersList from '../components/Partners';
import Repertoire from '../components/Repertoire';
import UpcomingPerformance from '../components/UpcomingPerformance';

const Home = () => {



  return (
     <div className="home">





       <Hero />


      <About />

       <section className='home__artists'>
       <h2>Our Artists</h2>
       <div className="home__artists-grid">
          <Artists />
          </div>
      </section>

      <section className='home__repertoire-grid'>
        <Repertoire />
      </section>

      <section className="home__events">
        <div className="home__events-grid">
          <UpcomingPerformance />
          <EventList/>
        </div>
      </section>
      
      <section className='home__locations'>
      <h2>Our Locations</h2>
      </section>
       <Locations/>

    <section>
    <h2 className='home__audio'>Listen...</h2>
      <Audio />
    </section>


      <section>
        <PartnersList />
      </section>
    </div>
  );
};

export default Home;
